/**
 * @generated SignedSource<<351cfc5f593f05903a2295ed07018e0e>>
 * @relayHash a4627ffdde76fe559dd5d7e1dc1e4276
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2a7d850fa8c1a6f919a6e61dafc3c775948c922f0c70a3fcecb66574478e38d

import type { ConcreteRequest } from 'relay-runtime';
export type WhiteboardTokenQuery$variables = {
  contentId: string;
};
export type WhiteboardTokenQuery$data = {
  readonly canvasToken: {
    readonly token: string;
  } | null;
  readonly contentMediaSession: {
    readonly accessTokens: {
      readonly readOnlyToken: {
        readonly value: string;
      } | null;
      readonly readWriteToken: {
        readonly value: string;
      } | null;
    };
    readonly configuration: {
      readonly fileStoreUrl: string;
    };
  } | null;
  readonly entitlements: {
    readonly whiteboardFeatures: {
      readonly smartConnectors: {
        readonly isEntitled: boolean;
      } | null;
      readonly smartSections: {
        readonly isEntitled: boolean;
      } | null;
    } | null;
  } | null;
};
export type WhiteboardTokenQuery = {
  response: WhiteboardTokenQuery$data;
  variables: WhiteboardTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v3 = [
  {
    "kind": "ScalarField",
    "name": "isEntitled"
  }
],
v4 = [
  {
    "args": (v1/*: any*/),
    "concreteType": "CanvasToken",
    "kind": "LinkedField",
    "name": "canvasToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "token"
      }
    ]
  },
  {
    "args": (v1/*: any*/),
    "concreteType": "ContentMediaSession",
    "kind": "LinkedField",
    "name": "contentMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MediaAccessTokens",
        "kind": "LinkedField",
        "name": "accessTokens",
        "plural": false,
        "selections": [
          {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "readOnlyToken",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "readWriteToken",
            "plural": false,
            "selections": (v2/*: any*/)
          }
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          }
        ]
      }
    ]
  },
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "WhiteboardFeatures",
        "kind": "LinkedField",
        "name": "whiteboardFeatures",
        "plural": false,
        "selections": [
          {
            "concreteType": "SmartConnectorsFeature",
            "kind": "LinkedField",
            "name": "smartConnectors",
            "plural": false,
            "selections": (v3/*: any*/)
          },
          {
            "concreteType": "SmartSectionsFeature",
            "kind": "LinkedField",
            "name": "smartSections",
            "plural": false,
            "selections": (v3/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WhiteboardTokenQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WhiteboardTokenQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a4627ffdde76fe559dd5d7e1dc1e4276",
    "id": "a2a7d850fa8c1a6f919a6e61dafc3c775948c922f0c70a3fcecb66574478e38d",
    "metadata": {},
    "name": "WhiteboardTokenQuery",
    "operationKind": "query",
    "text": "query WhiteboardTokenQuery($contentId:ID!){canvasToken(contentId:$contentId){token},contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}}}"
  }
};
})();

(node as any).hash = "b930e6a2afb104f531d81c694d4e3b98";

export default node;
